module.exports = __webpack_public_path__ + "static/fonts/Fact-NarrowBlack.381d1e4.woff";